import { render, staticRenderFns } from "./Navs.vue?vue&type=template&id=533694a4&"
import script from "./Navs.vue?vue&type=script&lang=js&"
export * from "./Navs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533694a4')) {
      api.createRecord('533694a4', component.options)
    } else {
      api.reload('533694a4', component.options)
    }
    module.hot.accept("./Navs.vue?vue&type=template&id=533694a4&", function () {
      api.rerender('533694a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/Navs.vue"
export default component.exports